import { EditBannerModel } from "@truckdown/locations";
import { IValidator } from "../../Validation/IValidator";

interface IPropertyValidator {
    key: string;
    validator: () => boolean;
    message: () => string;
}

export class BannerValidator implements IValidator {
    constructor(updateModel: EditBannerModel) {
        this._updateModel = updateModel;
        this._validators = this.getValidators();
    }

    private _updateModel: EditBannerModel;
    private _validators: IPropertyValidator[];

    private getValidators(): IPropertyValidator[] {
        return [
            {
                key: "countryCode",
                message: () => "Country is required.",
                validator: () => !!this._updateModel?.countryCode && this._updateModel?.countryCode.length > 0
            },
            {
                key: "regionCode",
                message: () => "State/Province is required.",
                validator: () => (!!this._updateModel?.regionCode && this._updateModel?.regionCode.length > 0) || this._updateModel?.countryCode != ""
            },
            
            {
                key: "website",
                message: () => this.websiteValidationMessage(this._updateModel?.websiteAddress),
                validator: () => this.isValidWebsite(this._updateModel?.websiteAddress)
            },
            {
                key: "image",
                message: () => "Banner image is required.",
                validator: () => !!this._updateModel?.imageId && this._updateModel?.imageId.length > 0
            }
        ];
    };

    isValidWebsite(url: string | null | undefined): boolean {
        if (!url) return false;

        const value = url.trim();
        const pattern =
            /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;

        return pattern.test(value);
    };

    websiteValidationMessage (url: string | null | undefined): string {
        if (!url) return "Website address is required";
        else if (!this.isValidWebsite(url))
            return "Invalid website format.";
        else {
            return "";
        } 
    };

    validate(key?: string): boolean {
        if (key) {
            let validator = this._validators.find(v => v.key == key);
            if (validator) {
                const isValid = validator.validator();
                if (!isValid) {
                    this.errors[key] = validator.message();
                } else {
                    delete this.errors[key];
                }
                return isValid;
            }
            return true;
        } else {
            let isValid = true;
            for (let i = 0; i < this._validators.length; i++) {
                let v = this._validators[i];
                if (!v.validator()) {
                    isValid = false;
                    delete this.errors[v.key];
                    this.errors[v.key] = v.message();
                } else {
                    delete this.errors[v.key];
                }
            }
            return isValid;
        }
    };

    reset() {
        this.errors = {};
    };

    errors: { [key: string]: string } = {};
}